import { useContext, useMemo } from 'react';

import { Link } from '../Link';
import { CaretLeftIcon } from '@buzzfeed/react-components';
import { useUnitTracking } from '../../hooks/analytics/useUnitTracking';
import { ProfileUserContext } from '../../contexts/profileUser';
import { withTranslation } from '../../i18n';
import styles from './index.scss';

const createTrackingData = ({ uuid }) => () => ({
  unit_type: 'trophies_head',
  unit_name: uuid,
  item_type: 'text',
  item_name: 'back to profile',
  position_in_unit: 0,
  target_content_type: 'user',
  target_content_id: uuid,
});

function BackToProfile({ username, t }) {
  const { uuid } = useContext(ProfileUserContext);
  const unitTrackingData = useMemo(createTrackingData({ uuid }), [uuid]);
  const ref = useUnitTracking(unitTrackingData);

  return (
    <Link
      href={`/${username}`}
      className={styles.backLink}
      aria-label={t('back_to_profile')}
      ref={ref}
    >
      <div className={styles.backButton}>
        <CaretLeftIcon className={styles.backButtonIcon} />
        {t('back_to_profile')}
      </div>
    </Link>
  );
}

export default withTranslation('common')(BackToProfile);
